## Services

- [www.yude.jp.eu.org](https://www.yude.jp.eu.org)

## Links

- [GitHub Organization](https://github.com/yudejp)
- [Discord server](https://discord.gg/X6srY7X)
